import { render, staticRenderFns } from "./BlujayGsoftDetail.vue?vue&type=template&id=5fa391c0&scoped=true&"
import script from "./BlujayGsoftDetail.vue?vue&type=script&lang=js&"
export * from "./BlujayGsoftDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlujayGsoftDetail.vue?vue&type=style&index=0&id=5fa391c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa391c0",
  null
  
)

export default component.exports